import { TEAM_MEMBER_VALUES } from "~/common/constants";
import { useGetCurrentTeamMember } from "../queries";

export const useIsTeamMemberStaff = () => {
  const { data: teamMember } = useGetCurrentTeamMember();
  const isStaff = teamMember?.type === TEAM_MEMBER_VALUES.staff;
  return { isStaff };
};
